import React from "react";

const STATUS_CONFIG = {
  pre_market: {
    label: "Pre-Market",
    color: "hsl(var(--status-pre))",
    bg: "hsl(var(--status-pre) / 0.12)",
    pulse: true,
  },
  live: {
    label: "Live",
    color: "hsl(var(--status-live))",
    bg: "hsl(var(--status-live) / 0.12)",
    pulse: true,
  },
  closed: {
    label: "Closed",
    color: "hsl(var(--status-closed))",
    bg: "hsl(var(--status-closed) / 0.10)",
    pulse: false,
  },
};

export const StatusBadge = ({ status, className = "" }) => {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.pre_market;
  return (
    <span
      className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-full text-xs font-medium tracking-wide ${className}`}
      style={{ color: cfg.color, backgroundColor: cfg.bg }}
      data-testid={`status-badge-${status}`}
    >
      {cfg.pulse ? (
        <span className="pulse-dot" style={{ backgroundColor: cfg.color }} />
      ) : (
        <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: cfg.color }} />
      )}
      {cfg.label}
    </span>
  );
};
